import React, {useEffect, useState} from "react";
import {BoxIsolatedContent, FlexColumnCentered, FormGoBack} from "../../../components/ui/Content";
import {Body1, Body1Pointer, FormTitle} from "../../../components/Font";
import {useTheme} from "styled-components";
import {useTranslation} from "react-i18next";
import {InputElement} from "../../../ui/Input/Input";
import {cleanError, clearCountdown, ConfirmRecoveryCode, RepeatRecoveryCode, setRecoveryStep} from "../slice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {RecoveryCodeContent, RecoveryInputContainer, RegisterInputContainer} from "../../../components/ui/InputSearch";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../ui/Loader/MiniLoader";
import moment from "moment/moment";
import {useLocation, useNavigate} from "react-router-dom";
import {RecoveryType} from "../../../enum/auth";
import {GoBack} from "../../../icon/Icon";
import {RecoveryStepEnum} from "../../../enum/auth";

export const RecoveryPhoneCode = () => {

    const Theme = useTheme()
    const {t} = useTranslation();
    const dispatch = useAppDispatch()
    const {retryAfter, smsPending, error, recoveryType, sentTo} = useAppSelector((state) => state.auth)
    const [code, setCode] = useState<string>('')
    const [countdown, setCountdown] = useState(0)
    const navigate = useNavigate()
    const {search} = useLocation()

    const token = localStorage.getItem('recoveryToken')
    useEffect(() => {
        if (!token) {
            navigate(`/sign-in${search}`)
        }
    }, [])

    useEffect(() => {
        if (retryAfter) {
            setCountdown(retryAfter)
        }
    }, [retryAfter])

    useEffect(() => {
        const count = () => {
            if (countdown > 0) {
                setCountdown(countdown - 1)
            } else {
                dispatch(clearCountdown())
            }
        }
        const timeout = setTimeout(count, 1000)
        return () => clearTimeout(timeout)
    }, [countdown])

    useEffect(() => {
        if (code.length === 6 && token) {
            dispatch(ConfirmRecoveryCode({token, code}))
            setCode('')
        }
    }, [code])

    const text: Record<number, Record<string, string>> = {
        [RecoveryType.Phone] : {
            title: t('auth.recoveryByPhone'),
            placeholder: t('auth.smsCode')
        },
        [RecoveryType.Email] : {
            title:  t('auth.recoveryByEmail'),
            placeholder: t('auth.confirmCode')
        }
    }

   return <FlexColumnCentered className={'box-isolated'}>
        <BoxIsolatedContent>
            <FlexColumnCentered style={{width: '100%'}}>
                <FormGoBack onClick={() => {
                    dispatch(setRecoveryStep(RecoveryStepEnum.Recovery))
                }}>
                    <GoBack/>
                </FormGoBack>
                <FormTitle>{t('auth.passwordRecovery')}</FormTitle>
                <Body1 style={{textAlign: 'center', width: '270px', marginTop: '12px'}}>
                    {recoveryType && text[recoveryType].title} {sentTo}
                </Body1>
            </FlexColumnCentered>
            <RegisterInputContainer>
                <RecoveryInputContainer>
                    <InputElement
                        autofocus={true}
                        value={code}
                        format={'###-###'}
                        mask={'_'}
                        error={error['code']}
                        onChange={value => {
                            setCode(value)
                            if (error['code']) {
                                dispatch(cleanError('code'))
                            }
                        }}
                        onKeyDown={(key) => {
                            if (key === 'Enter' && code.length === 6 && token) {
                                dispatch(ConfirmRecoveryCode({token, code}))
                                setCode('')
                            }
                        }}
                        placeholder={`${recoveryType && text[recoveryType].placeholder}`}
                    />
                </RecoveryInputContainer>
            </RegisterInputContainer>
            <RecoveryCodeContent>
                {countdown <= 0
                    ? <>{smsPending
                        ? <LoaderContainer>
                            <MiniLoader color={Theme.color.indicator} size={LoaderEnum.small}/>
                        </LoaderContainer>
                        : <Body1Pointer color={Theme.color.indicator} onClick={() => {
                            if (token) {
                                dispatch(RepeatRecoveryCode({token, sentTo}))
                            }
                        }}>
                            {t('auth.retryCode')}
                        </Body1Pointer>}</>

                    : <Body1 color={Theme.color.secondary}>
                        {t('auth.sendAgainIn')} {moment.utc(countdown * 1000).format('mm:ss')}
                    </Body1>
                }
            </RecoveryCodeContent>
        </BoxIsolatedContent>
    </FlexColumnCentered>
}
